<template>
    <div>
        <ul class="nav nav-tabs px-3 tabs mb-3 mt-3" role="tablist">
            <li class="nav-item">
                <button
                    class="nav-link"
                    :class="{ active: currentTab === 'tab1', 'text-muted': currentTab !== 'tab1' }"
                    @click="currentTab = 'tab1'"
                >
                    {{ $t('marketing.campaigns.list_view') }}
                </button>
            </li>
            <li class="nav-item">
                <button
                    class="nav-link"
                    :class="{ active: currentTab === 'tab2', 'text-muted': currentTab !== 'tab2' }"
                    @click="currentTab = 'tab2'"
                >
                    {{ $t('marketing.campaigns.calendar_view') }}
                </button>
            </li>
            <li class="nav-item">
                <button
                    class="nav-link"
                    :class="{ active: currentTab === 'tab3', 'text-muted': currentTab !== 'tab3' }"
                    @click="currentTab = 'tab3'"
                >
                    {{ $t('marketing.campaigns.stats_view') }}
                </button>
            </li>
        </ul>
        <div class="tab-content">
            <component
                :is="currentTab"
                :url_btn_campaigne_email_create="url_btn_campaigne_email_create"
                :url_btn_campaigne_email_models="url_btn_campaigne_email_models"
                :url_btn_campaigne_index="url_btn_campaigne_index"
                :establishment="establishment"
            >
            </component>
        </div>
    </div>
</template>

<script>
import CompaingEmails from './CompaingEmails.vue'
import CampaingEmailCalender from './CampaingEmailCalender.vue'
import CampaingEmailList from './CampaingEmailList.vue'

export default {
    name: 'CampaingEmailIndex',
    props: ['url_btn_campaigne_email_create', 'url_btn_campaigne_email_models', 'url_btn_campaigne_index', 'establishment'],
    components: {
        tab1: CompaingEmails,
        tab2: CampaingEmailCalender,
        tab3: CampaingEmailList,
    },
    data: () => ({
        mode: 'light',
        currentTab: 'tab1',
    }),
    methods: {},
}
</script>

<style>
.text-muted {
    color: #94a3b8 !important;
}
</style>
